import React, { Fragment } from "react";
import PropTypes from "prop-types";
import
{
  useTable,
  useGlobalFilter,
  useAsyncDebounce,
  useSortBy,
  useFilters,
  useExpanded,
  usePagination,
  useRowSelect,
} from "react-table";
import { Table, Row, Col, Button, Input, CardBody } from "reactstrap";
import { Filter, DefaultColumnFilter, SelectColumnFilter } from "./filters";
import Select from "react-select";

import
{
  ProductsGlobalFilter,
  CustomersGlobalFilter,
  OrderGlobalFilter,
  ContactsGlobalFilter,
  CompaniesGlobalFilter,
  LeadsGlobalFilter,
  CryptoOrdersGlobalFilter,
  InvoiceListGlobalSearch,
  TicketsListGlobalFilter,
  NFTRankingGlobalFilter,
  TaskListGlobalFilter,
} from "../../Components/Common/GlobalSearchFilter";

// Define a default UI for filtering
function GlobalFilter ( {
  preGlobalFilteredRows,
  globalFilter,
  setGlobalFilter,
  isStatusFilter,
  setStatusFilter,
  isCustomerFilter,
  isOrderFilter,
  isContactsFilter,
  isCompaniesFilter,
  isCryptoOrdersFilter,
  isInvoiceListFilter,
  isTicketsListFilter,
  isNFTRankingFilter,
  isTaskListFilter,
  isProductsFilter,
  isLeadsFilter,
} )
{
  const count = preGlobalFilteredRows.length;
  const [ value, setValue ] = React.useState( globalFilter );
  const onChange = useAsyncDebounce( ( value ) =>
  {
    setGlobalFilter( value || undefined );
  }, 200 );

  const [ statusFilter, setSelectedStatusFilter ] = React.useState( "" );

  function handleCustomerStatus ( customer_status )
  {
    setSelectedStatusFilter( customer_status );
    setStatusFilter( customer_status || undefined );
  }

  return (
    <React.Fragment>
      <CardBody className="border border-dashed border-end-0 border-start-0">
        <form>
          <Row>
            <Col sm={ 5 }>
              <div
                className={
                  isProductsFilter ||
                    isContactsFilter ||
                    isCompaniesFilter ||
                    isNFTRankingFilter
                    ? "search-box me-2 mb-2 d-inline-block"
                    : "search-box me-2 mb-2 d-inline-block col-12"
                }
              >
                <input
                  onChange={ ( e ) =>
                  {
                    setValue( e.target.value );
                    onChange( e.target.value );
                  } }
                  id="search-bar-0"
                  type="text"
                  className="form-control search /"
                  placeholder={ `${ count } Search...` }
                  value={ value || "" }
                />
                <i className="bx bx-search-alt search-icon"></i>
              </div>
            </Col>

            {/* {isStatusFilter && (
              <Col xl={7}>
                <Row className="g-3 justify-content-end">
                  <Col sm={6}>
                    <div>
                      <Select
                        placeholder={statusFilter || "Tous..."}
                        value={statusFilter}
                        onChange={(selectedOption) => {
                          handleCustomerStatus(selectedOption.value);
                        }}
                        options={isStatusFilter}
                        name="choices-single-default"
                        id="idStatus"
                      ></Select>
                    </div>
                  </Col>
                </Row>
              </Col>
            )} */}

            { isProductsFilter && <ProductsGlobalFilter /> }
            { isCustomerFilter && <CustomersGlobalFilter /> }
            { isOrderFilter && <OrderGlobalFilter /> }
            { isContactsFilter && <ContactsGlobalFilter /> }
            { isCompaniesFilter && <CompaniesGlobalFilter /> }
            { isLeadsFilter && <LeadsGlobalFilter /> }
            { isCryptoOrdersFilter && <CryptoOrdersGlobalFilter /> }
            { isInvoiceListFilter && <InvoiceListGlobalSearch /> }
            { isTicketsListFilter && <TicketsListGlobalFilter /> }
            { isNFTRankingFilter && <NFTRankingGlobalFilter /> }
            { isTaskListFilter && <TaskListGlobalFilter /> }
          </Row>
        </form>
      </CardBody>
    </React.Fragment>
  );
}

const TableContainer = ( {
  columns,
  data,
  isGlobalSearch,
  isGlobalFilter,
  isStatusFilter,
  isProductsFilter,
  isCustomerFilter,
  isOrderFilter,
  isContactsFilter,
  isCompaniesFilter,
  isLeadsFilter,
  isCryptoOrdersFilter,
  isInvoiceListFilter,
  isTicketsListFilter,
  isNFTRankingFilter,
  isTaskListFilter,
  isAddOptions,
  isAddUserList,
  handleOrderClicks,
  handleUserClick,
  handleCustomerClick,
  isAddCustList,
  customPageSize,
  tableClass,
  theadClass,
  trClass,
  thClass,
  divClass,
  currentPage,
  onPageChange,
} ) =>
{
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state,
    preGlobalFilteredRows,
    setGlobalFilter,
    setStatusFilter,
    state: { pageIndex, pageSize },

  } = useTable(
    {
      columns,
      data,
      defaultColumn: { Filter: DefaultColumnFilter },
      initialState: {
        pageIndex: 0,
        pageSize: customPageSize,
        selectedRowIds: 0,
        sortBy: [
          {
            desc: true,
          },
        ],
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const generateSortingIndicator = ( column ) =>
  {
    return column.isSorted ? ( column.isSortedDesc ? " " : "" ) : "";
  };

  const onChangeInSelect = ( event ) =>
  {
    setPageSize( Number( event.target.value ) );
  };

  const onChangeInInput = ( event ) =>
  {
    const page = event.target.value ? Number( event.target.value ) - 1 : 0;
    onPageChange( page )
    gotoPage( page );
  };

  React.useEffect( () =>
  {
    if ( currentPage !== pageIndex )
    {
      gotoPage( currentPage );
    }
  }, [ currentPage, pageIndex] );

  return (
    <Fragment>
      <Row className="mb-3">
        { isGlobalSearch && (
          <Col md={ 1 }>
            <select
              className="form-select"
              value={ pageSize }
              onChange={ onChangeInSelect }
            >
              { [ 10, 20, 30, 40, 50 ].map( ( pageSize ) => (
                <option key={ pageSize } value={ pageSize }>
                  Show { pageSize }
                </option>
              ) ) }
            </select>
          </Col>
        ) }
        { isGlobalFilter && (
          <GlobalFilter
            preGlobalFilteredRows={ preGlobalFilteredRows }
            globalFilter={ state.globalFilter }
            setGlobalFilter={ setGlobalFilter }
            isStatusFilter={ isStatusFilter }
            setStatusFilter={ setStatusFilter }
            isProductsFilter={ isProductsFilter }
            isCustomerFilter={ isCustomerFilter }
            isOrderFilter={ isOrderFilter }
            isContactsFilter={ isContactsFilter }
            isCompaniesFilter={ isCompaniesFilter }
            isLeadsFilter={ isLeadsFilter }
            isCryptoOrdersFilter={ isCryptoOrdersFilter }
            isInvoiceListFilter={ isInvoiceListFilter }
            isTicketsListFilter={ isTicketsListFilter }
            isNFTRankingFilter={ isNFTRankingFilter }
            isTaskListFilter={ isTaskListFilter }
          />
        ) }
        { isAddOptions && (
          <Col sm="7">
            <div className="text-sm-end">
              <Button
                type="button"
                color="success"
                className="btn-rounded  mb-2 me-2"
                onClick={ handleOrderClicks }
              >
                <i className="mdi mdi-plus me-1" />
                Add New Order
              </Button>
            </div>
          </Col>
        ) }
        { isAddUserList && (
          <Col sm="7">
            <div className="text-sm-end">
              <Button
                type="button"
                color="primary"
                className="btn mb-2 me-2"
                onClick={ handleUserClick }
              >
                <i className="mdi mdi-plus-circle-outline me-1" />
                Create New User
              </Button>
            </div>
          </Col>
        ) }
        { isAddCustList && (
          <Col sm="7">
            <div className="text-sm-end">
              <Button
                type="button"
                color="success"
                className="btn-rounded mb-2 me-2"
                onClick={ handleCustomerClick }
              >
                <i className="mdi mdi-plus me-1" />
                New Customers
              </Button>
            </div>
          </Col>
        ) }
      </Row>

      <Row className="mb-3 g-3 justify-content-end">
        { headerGroups.map( ( headerGroup ) =>
          headerGroup.headers.map(
            ( column ) =>
              column.filterable && (
                <Col md={ 6 } lg={ 4 } key={ column.id } className="mb-3">
                  <SelectColumnFilter column={ column } />
                </Col>
              )
          )
        ) }
      </Row>

      <div className={ divClass }>
        <Table hover { ...getTableProps() } className={ tableClass }>
          <thead key={ theadClass } className={ theadClass }>
            { headerGroups.map( ( headerGroup ) => (
              <tr
                className={ trClass }
                key={ headerGroup.id }
                { ...headerGroup.getHeaderGroupProps() }
              >
                { headerGroup.headers.map( ( column ) => (
                  <>
                    <th
                      key={ column.id }
                      className={ thClass }
                      { ...column.getSortByToggleProps() }
                    >
                      { column.render( "Header" ) }
                      { generateSortingIndicator( column ) }
                      {/* {headerGroup.filterable && (
                        <SelectColumnFilter key={column.id} column={column} />
                      )} */}
                    </th>
                  </>
                ) ) }
              </tr>
            ) ) }
          </thead>

          <tbody { ...getTableBodyProps() }>
            { page.map( ( row, index ) =>
            {
              prepareRow( row );
              return (
                <Fragment key={ index }>
                  <tr>
                    { row.cells.map( ( cell, key ) =>
                    {
                      return (
                        <td key={ index + key } { ...cell.getCellProps() }>
                          { cell.render( "Cell" ) }
                        </td>
                      );
                    } ) }
                  </tr>
                </Fragment>
              );
            } ) }
          </tbody>
        </Table>
      </div>

      <Row className="justify-content-md-end justify-content-center align-items-center p-2">
        <Col className="col-md-auto">
          <div className="d-flex gap-1">
            <Button
              color="primary"
              onClick={ previousPage }
              disabled={ !canPreviousPage }
            >
              { "<" }
            </Button>
          </div>
        </Col>
        <Col className="col-md-auto d-none d-md-block">
          Page{ " " }
          <strong>
            { pageIndex + 1 } of { pageOptions.length }
          </strong>
        </Col>
        <Col className="col-md-auto">
          <Input
            type="number"
            min={ 1 }
            style={ { width: 70 } }
            max={ pageOptions.length }
            defaultValue={ pageIndex + 1 }
            onChange={ onChangeInInput }
          />
        </Col>

        <Col className="col-md-auto">
          <div className="d-flex gap-1">
            <Button color="primary" onClick={ nextPage } disabled={ !canNextPage }>
              { ">" }
            </Button>
          </div>
        </Col>
      </Row>
    </Fragment>
  );
};

TableContainer.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
};

export default TableContainer;
